import { useQuery } from '@ltvco/refresh-lib/vendors';

import {
  API_CONFIG,
  DEFAULT_QUERY_OPTIONS,
  makeAuthenticatedGetRequest,
  useBaseCourtApi,
} from '../../shared/hooks/useBaseCourtApi';

import type { DocketDetailResponse } from './types';

const isValidDocketId = (id: string | undefined): id is string =>
  Boolean(id && /^\d+$/.test(id.trim()));

export function useDocketDetailReport(docketId: string | undefined) {
  const {
    makeApiCall,
    isLoading: isTokenLoading,
    tokenData,
  } = useBaseCourtApi();

  const trimmed = docketId?.trim();
  const enabled =
    isValidDocketId(trimmed) && !isTokenLoading && !!tokenData?.token;

  return useQuery(
    ['legal-docket-detail', trimmed],
    () =>
      makeApiCall(async (token) => {
        const url = `${
          API_CONFIG.BASE_URL
        }/legal/docket-detail?docket_id=${encodeURIComponent(trimmed!)}`;
        return makeAuthenticatedGetRequest<DocketDetailResponse>(url, token);
      }),
    {
      ...DEFAULT_QUERY_OPTIONS,
      enabled,
    }
  );
}
